import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  TRACK_CLICK = "TRACKS_TRACK_CLICK",
  RACE_NAVIGATION = "RACE_NAVIGATION",
  FILTER_CLICK = "TRACKS_FILTER_CLICK"
}

export interface TrackClickData {
  type: MediatorEventType.TRACK_CLICK;
  payload: {
    isOpen: boolean;
    trackName: string;
    tag: string;
    module: string;
    isGreyhound?: boolean;
  };
}

export interface RaceNavigationData {
  type: MediatorEventType.RACE_NAVIGATION;
  payload: {
    trackName: string;
    raceNumber: string;
    mtp: number;
    module: string;
    url: string;
  };
}

export interface FilterClickData {
  type: MediatorEventType.FILTER_CLICK;
  payload: {
    filter: string;
    numRacesUpNext?: number;
    numRacesResultUpNext?: number;
    numRacesFavorites?: number;
    numRacesResultFavorites?: number;
    numRacesAZ?: number;
    numRacesResultAZ?: number;
    isSelecting?: boolean;
  };
}
